import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressMarker',
  props: {
    value: null,
    color: null
  },
  setup(__props) {
    const props = __props;
    const colorMap = generateColorMap({
      bg: 800
    });
    const classes = computed(() => ({
      '-ml-0.5': props.value > 2,
      '-ml-1': props.value >= 98,
      [colorMap[props.color]]: true
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["h-4 absolute -my-3 w-1 rounded", _unref(classes)]),
        style: _normalizeStyle({
          left: `${__props.value}%`
        })
      }, null, 6);
    };
  }
});